import * as React from "react";
import Svg, { Path, SvgProps } from "react-native-svg";
import { cssInterop } from "nativewind";

cssInterop(Svg, {
  className: {
    target: "style",
    nativeStyleToProp: { width: true, height: true },
  },
});

cssInterop(Path, {
  className: {
    // @ts-ignore
    target: "style",
    nativeStyleToProp: { stroke: true },
  },
});

type WarningOutlineIconProps = SvgProps & {
  className?: string;
  pathClassName?: string;
};

function WarningOutlineIcon({
  className,
  pathClassName = "stroke-gray-800",
  ...props
}: WarningOutlineIconProps) {
  return (
    <Svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      {...props}
    >
      <Path
        d="M12 2.5A9.5 9.5 0 002.5 12a9.5 9.5 0 1019 0A9.5 9.5 0 0012 2.5zM11.996 6.722v6.333"
        className={pathClassName}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M12.044 16.557h-.009"
        className={pathClassName}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
}

export default WarningOutlineIcon;
